"use strict";

require("core-js/modules/es6.object.define-property");

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rich_text_types_1 = require("@contentful/rich-text-types");

var util_1 = require("@lws/react-components/dist/components/RichTextRenderer/renderers/entry-item/util");

var entry_item_1 = require("@lws/react-components/dist/components/RichTextRenderer/renderers/entry-item");

exports.withFootnotesAndCustomBlocks = {
  renderNode: (_a = {}, _a[rich_text_types_1.INLINES.EMBEDDED_ENTRY] = util_1.composeEntryLinkRendererUsing({
    Footnote: entry_item_1.renderFootnote
  }), _a[rich_text_types_1.BLOCKS.EMBEDDED_ENTRY] = util_1.composeEntryLinkRendererUsing({
    CheckmarkItem: entry_item_1.renderCheckmarkListItem
  }), _a)
};